const trans = {
  // Page chrome
  "Reports overview": "نظرة عامة",
  "A live snapshot across sales, customers, products, delivery and promotions.":
    "لمحة حية عن المبيعات والعملاء والمنتجات والتوصيل والعروض.",
  "PDF summary": "ملخص PDF",

  // Revenue trend
  "Revenue trend": "اتجاه الإيرادات",
  "Sales performance over the selected period": "أداء المبيعات خلال الفترة المحددة",
  Day: "يومي",
  Week: "أسبوعي",

  // Needs attention
  "Needs attention": "يحتاج إلى انتباه",
  "Ranked by impact, shown only when notable":
    "مرتبة حسب الأهمية، وتظهر فقط عند وجود ملاحظات",
  "Nothing needs attention in this period":
    "لا يوجد ما يحتاج إلى انتباه في هذه الفترة",

  // Channels
  "Sales by channel": "المبيعات حسب القناة",
  "Revenue mix and movement by source": "توزيع الإيرادات وتغيّرها حسب المصدر",
  Storefront: "المتجر الإلكتروني",
  POS: "نقطة البيع",
  "Mobile App": "تطبيق الجوال",
  Other: "أخرى",

  // Peak hours
  "Peak hours": "ساعات الذروة",
  "Order volume by day and hour": "حجم الطلبات حسب اليوم والساعة",

  // KPI cards
  snapshot: "لقطة",
  Open: "فتح",
  New: "جديد",
  "Gross sales": "إجمالي المبيعات",
  "Net sales": "صافي المبيعات",
  "Average order value": "متوسط قيمة الطلب",
  "Recorded discounts": "الخصومات المسجلة",
  Refunds: "المبالغ المستردة",
  "Abandoned orders": "الطلبات المتروكة",
  "Inventory value": "قيمة المخزون",
  Discount: "الخصم",
  "Never sold": "لم تُبَع أبدًا",
  "Low stock": "مخزون منخفض",
  "On-time": "في الوقت المحدد",
  "Avg time": "متوسط الوقت",
  min: "دقيقة",
  "Coupon usage": "استخدام الكوبونات",

  // Currency codes
  KD: "د.ك",
  KWD: "د.ك",
  SAR: "ر.س",
  SR: "ر.س",
  AED: "د.إ",
  BHD: "د.ب",
  QAR: "ر.ق",
  OMR: "ر.ع",
  USD: "$",
  EGP: "ج.م",
  JOD: "د.أ",
  GBP: "£",
  EUR: "€",

  // KPI hints
  "Sales before discounts, refunds and tax":
    "المبيعات قبل الخصومات والمبالغ المستردة والضريبة",
  "What you kept after discounts and refunds":
    "ما تبقّى لك بعد الخصومات والمبالغ المستردة",
  "Completed orders in the period": "الطلبات المكتملة خلال الفترة",
  "Net sales divided by orders": "صافي المبيعات مقسومًا على عدد الطلبات",
  "Customers who ordered in the period": "العملاء الذين طلبوا خلال الفترة",
  "Total value given away as discounts": "إجمالي القيمة الممنوحة كخصومات",
  "Money returned to customers": "الأموال المُعادة للعملاء",
  "Orders awaiting completed payment (current backlog, last 48h)":
    "طلبات بانتظار إتمام الدفع (الرصيد الحالي، آخر ٤٨ ساعة)",
  "Current stock value on hand": "قيمة المخزون الحالي المتوفر",

  // Weekdays (heatmap)
  Mon: "الاثنين",
  Tue: "الثلاثاء",
  Wed: "الأربعاء",
  Thu: "الخميس",
  Fri: "الجمعة",
  Sat: "السبت",
  Sun: "الأحد",

  // Shared report filter bar
  Filter: "تصفية",
  Today: "اليوم",
  Yesterday: "أمس",
  "Last Week": "الأسبوع الماضي",
  "Last Month": "الشهر الماضي",
  "Last 30 Days": "آخر ٣٠ يومًا",
  "Custom Range": "نطاق مخصص",
  Custom: "مخصص",
  "All channels": "كل القنوات",
  "All sources": "كل المصادر",
  "All payments": "كل طرق الدفع",
  "All types": "كل الأنواع",
  "All categories": "كل الفئات",
  "All products": "كل المنتجات",
  Status: "الحالة",
  "More filters": "مزيد من عوامل التصفية",

  // Needs-attention feed (templated — {{...}} placeholders must match)
  "Refunds up {{pct}}": "ارتفعت المبالغ المستردة {{pct}}",
  "{{currency}} {{amount}} across {{orders}} orders":
    "{{currency}} {{amount}} عبر {{orders}} طلبات",
  "Net sales down {{pct}}": "انخفض صافي المبيعات {{pct}}",
  "Net sales up {{pct}}": "ارتفع صافي المبيعات {{pct}}",
  "Compared with the previous period": "مقارنةً بالفترة السابقة",
  "Avg order value down {{pct}}": "انخفض متوسط قيمة الطلب {{pct}}",
  "Customers are spending less per order": "العملاء ينفقون أقل لكل طلب",
  "Discounts up {{pct}}": "ارتفعت الخصومات {{pct}}",
  "{{currency}} {{amount}} given in discounts": "{{currency}} {{amount}} مُنحت كخصومات",
  "{{n}} orders awaiting payment": "{{n}} طلبات بانتظار الدفع",
  "Recover them before they are lost": "استرجعها قبل أن تُفقد",
  "Cash share fell to {{share}}%": "انخفضت حصة النقد إلى {{share}}%",
  "Cash share rose to {{share}}%": "ارتفعت حصة النقد إلى {{share}}%",
  "Was {{share}}% the previous period": "كانت {{share}}% في الفترة السابقة",
  "{{n}} low-stock items": "{{n}} عناصر منخفضة المخزون",
  "At or below holding inventory": "عند مستوى المخزون المحجوز أو أقل",
  "{{n}} products never sold": "{{n}} منتجات لم تُبَع أبدًا",
  "Items with zero sales all-time": "عناصر بدون أي مبيعات على الإطلاق",
  "Coupon {{code}} drove {{orders}} orders": "حقّق الكوبون {{code}} {{orders}} طلبًا",
  "{{currency}} {{amount}} in attributed revenue":
    "{{currency}} {{amount}} من الإيرادات المنسوبة",
  "Busiest: {{weekday}} around {{hour}}:00":
    "الأكثر ازدحامًا: {{weekday}} حوالي الساعة {{hour}}:00",
  "{{n}} orders in that hour": "{{n}} طلبات في تلك الساعة",

  // Full weekday names (used in the busiest-hour insight)
  Monday: "الاثنين",
  Tuesday: "الثلاثاء",
  Wednesday: "الأربعاء",
  Thursday: "الخميس",
  Friday: "الجمعة",
  Saturday: "السبت",
  Sunday: "الأحد",

  // Month abbreviations — only the month label in the period-select is translated;
  // the antd date-range picker itself stays in English.
  Jan: "يناير",
  Feb: "فبراير",
  Mar: "مارس",
  Apr: "أبريل",
  May: "مايو",
  Jun: "يونيو",
  Jul: "يوليو",
  Aug: "أغسطس",
  Sep: "سبتمبر",
  Oct: "أكتوبر",
  Nov: "نوفمبر",
  Dec: "ديسمبر",
};

export default trans;
